export default "__VITE_ASSET__Dq79fS27__"